import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { CharacterCount } from './components/CharacterCount';
import { BubbleMenu, EditorContent } from '@tiptap/react';
import { Box } from '@chakra-ui/react';
import { SubmitErrorComponent } from './components/SubmitError';
import type { EditorPreset } from './presets';
import { MenuBar } from './presets';
import { useEditorContext, withEditorContext } from './editor_context';

const TiptapEditorComponent = (props: {
   editorid: string;
   preset: EditorPreset;
   characterCountConfig?: boolean;
}) => {
   const { editorid, characterCountConfig, preset } = props;
   const { editor } = useEditorContext();
   const isFocused = editor?.storage.isFocused.isFocused;
   const submitError = editor?.storage.submitError.error;

   return (
      <>
         <Box id={editorid} className="ProseMirror-menubar-wrapper">
            <MenuBar preset={preset} />
            <EditorContent editor={editor} />
         </Box>
         {isFocused && characterCountConfig ? <CharacterCount /> : null}
         {submitError ? <SubmitErrorComponent error={submitError} /> : null}
      </>
   );
};

export const TiptapEditor = withEditorContext(TiptapEditorComponent);

initializeChakraComponent('TiptapEditor', TiptapEditor);
